import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { Text } from '@cko/primitives';

export const Button = styled.button`
  align-items: center;
  border-radius: var(--border-r-stamp);
  border: none;
  background-color: var(--base-bg-primary)
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
  padding: var(--layout-seed);
  color: var(--control-icon-primary);
  cursor: pointer;
    
  &:hover {
    background-color: var(--control-bg-decorative-hover);
    color: var(--control-icon-hover)
  }
      
  &:focus {
    color: var(--control-icon-focus)
    background-color: var(--control-bg-decorative-focus);
  }
`;

export const StyledPopoverContent = styled.div`
  min-width: 300px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: var(--layout-soybean);
`;

const AVATAR_SIZE_PX = '32px';
const USER_DETAILS_GAP = 'var(--layout-soybean)';

export const StyledUserAvatar = styled.div`
  border-radius: var(--border-r-circle);
  padding: var(--layout-seed);
  background: var(--control-bg-decorative-focus);
  height: ${AVATAR_SIZE_PX};
  width: ${AVATAR_SIZE_PX};
  justify-content: center;
  display: flex;
  font: var(--body-xs-emphasis);
`;

export const StyledNameAndRoleContainer = styled.div`
  display: flex;
  gap: ${USER_DETAILS_GAP};
`;

export const StyledNameContainer = styled.div`
  flex-wrap: wrap;
  display: flex;
  flex: 1 1 0;
  gap: ${USER_DETAILS_GAP};
  align-items: center;
  justify-content: space-between;
  max-width: calc(100% - ${AVATAR_SIZE_PX} - ${USER_DETAILS_GAP});
`;

export const StyledNameText = styled(Text)`
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  font: var(--heading-xs);
  text-overflow: ellipsis;
`;

export const StyledLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--layout-seed);
`;

const menuItemBaseStyle = css`
  background: var(--bg-primary);
  border: none;
  border-radius: var(--border-r-seed);
  color: var(--control-text-primary);
  cursor: pointer;
  display: block;
  font: var(--body-xs);
  padding: var(--layout-seed) var(--layout-soybean);
  text-align: left;
  text-decoration: none;
  width: 100%;

  &:focus-visible {
    border-radius: var(--border-r-seed);
    background-color: var(--control-bg-decorative-hover);
    outline: var(--border-b-soybean) solid var(--control-border-focus-ring);
  }

  :active,
  :hover {
    background-color: var(--control-bg-decorative-hover);
  }
`;

export const MenuLink = styled(NavLink)`
  ${menuItemBaseStyle}
`;

export const AccountDetailsButton = styled.button`
  ${menuItemBaseStyle}
`;

export const SignOutButton = styled.button`
  ${menuItemBaseStyle}
  color: var(--control-text-bad);
`;

